import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ThemeHandler = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Force light mode for all routes
    document.documentElement.classList.remove("dark");
    // Set light theme in localStorage to persist the preference
    localStorage.setItem("color-theme", "light");
  }, [location]);

  return null;
};

export default ThemeHandler;
